import { render, staticRenderFns } from "./Free.vue?vue&type=template&id=b3c50900&scoped=true&"
import script from "./Free.vue?vue&type=script&lang=js&"
export * from "./Free.vue?vue&type=script&lang=js&"
import style0 from "./Free.vue?vue&type=style&index=0&id=b3c50900&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c50900",
  null
  
)

export default component.exports